import * as yup from 'yup';

export const MIN_URLS = 1;
export const MAX_URLS = 100;

export const recipesImportSchema = yup.object({  
  items: yup.array().of(yup.object({
    url: yup.string().url('Invalid URL').required('URL is required'),
  })).required().min(1, 'At least one URL is required').max(100, 'At most 100 URLs are allowed'),
});

export function newItem() {
  return {
    url: '',
  };
}

export function newRecipesImport() {
  return {
    items: [newItem()],    
  };
}
